import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../../../shared/api/client'
import type {
  ManagerClientsByCategoryDto,
  ManagerPartHistoryDto,
  ManagerRequestDetailDto,
} from './types'

export function useManagerRequestDetail(requestId: string | null) {
  return useQuery({
    enabled: requestId !== null,
    queryKey: ['dashboard', 'manager', 'request', requestId],
    queryFn: async () => {
      const res = await apiClient.get<{ success: true; data: ManagerRequestDetailDto }>(
        `/dashboard/manager/request/${requestId}`,
      )
      return res.data.data
    },
  })
}

export function useManagerPartHistory(target: { partNumber: string; brand: string | null } | null) {
  return useQuery({
    enabled: target !== null,
    queryKey: ['dashboard', 'manager', 'part-history', target?.partNumber, target?.brand],
    queryFn: async () => {
      const res = await apiClient.get<{ success: true; data: ManagerPartHistoryDto }>(
        '/dashboard/manager/part-history',
        { params: { partNumber: target!.partNumber, brand: target!.brand ?? undefined } },
      )
      return res.data.data
    },
  })
}

export function useManagerClientsByCategory(category: 'A' | 'B' | 'C' | null) {
  return useQuery({
    enabled: category !== null,
    queryKey: ['dashboard', 'manager', 'clients-by-category', category],
    queryFn: async () => {
      const res = await apiClient.get<{ success: true; data: ManagerClientsByCategoryDto }>(
        '/dashboard/manager/clients-by-category',
        { params: { category } },
      )
      return res.data.data
    },
  })
}
